import { useState, useEffect } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { getRadars } from '@futures-platform/connectors/search-api'


export const useTemplateSearchForCreateRadar = (search, language, isEmpty = false, excludedRadarIds=[]) => {
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [fetchRadars] = useDebouncedCallback(async (query, language, excludedRadarIds) => {
    try {
      setResults((await getRadars(query, language, isEmpty,fields = ['id', 'uuid', 'content.title', 'content.sectors.id', 'content.sectors.title', 'content.preview_image'], groups = [0], page = 0, size = 3, template = true, enhanced = 1, excludedRadarIds)
        .then(({ result }) => {
          setLoading(false)
          return result
        })))
    } catch (err) {
      setLoading(false)
      setError(err.message)
    }
  }, 500)


    useEffect(() => {
    if (search || isEmpty) {

      setLoading(true)

      fetchRadars(search, language, excludedRadarIds)


    } else {
      setResults([])
    }
  }, [fetchRadars, search, language, isEmpty, excludedRadarIds])

  return {
    results,
    loading,
    error
  }
}

export const useTemplateSearch = (search, language, isEmpty = false) => {
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [fetchRadars] = useDebouncedCallback(async (query, language) => {
    try {
      setResults((await getRadars(query, language, isEmpty)
        .then(({ result }) => {
          setLoading(false)
          return result
        })))
    } catch (err) {
      setLoading(false)
      setError(err.message)
    }
  }, 500)


    useEffect(() => {
    if (search || isEmpty) {

      setLoading(true)

      fetchRadars(search, language)


    } else {
      setResults([])
    }
  }, [fetchRadars, search, language, isEmpty])

  return {
    results,
    loading,
    error
  }
}